<div class="text-red-600 text-xxs flex flex-row items-center gap-1 leading-5">
    <i class="fa-solid fa-exclamation-circle"></i>
    <span>
        {{ "txt_valid_vmail"| translate:language:ModuleNames.Shared }}
    </span>

</div>
